import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';
import cn from 'classnames';
import { useReactiveVar } from '@apollo/client';

import MainContent from 'components/layout/MainContent';

import { GlobalHead } from './GlobalHead';

import { useTheme } from 'hooks/utils/useTheme';

import { themeVar } from 'store/theme';

import { IS_PRODUCTION } from 'utils/envs';
import { snakeToCamelCase } from 'utils/helpers';

import css from './Layout.module.scss';

interface IProps {
  children: ReactNode;
}

export default function Layout({ children }: IProps) {
  const router = useRouter();
  const { name: themeName } = useReactiveVar(themeVar);

  useTheme();

  useEffect(() => {
    if (ZnanieSDK) {
      ZnanieSDK.init({
        elem: document.getElementById('znanie-header'),
        footerElem: document.getElementById('znanie-footer'),
        disableAnalytics: !IS_PRODUCTION,
        headerProps: {
          enableNotifications: true,
        },
        // включаем скрытую опцию, которая превращает все навигационные ссылки в относительные
        _usage: 'internal',
      });

      // подписываемся на нажатие любой навигационной ссылки (в рамках нашего сайта) из хедера/футера
      ZnanieSDK.on('linkClick', async (url: string) => {
        // вручную осуществляем навигацию, чтобы сохранить поведение гибридного приложения,
        // а не полностью заново все отрисовывать после перехода
        await router.push(url);
      });

      // отображаем модалку с полями персональных данных, если они не заполнены у пользователя
      ZnanieSDK.showPersonalDataForm();
    }
  }, []);

  return (
    <>
      <GlobalHead />
      <div className={cn(css.root, css[snakeToCamelCase(`root_${themeName}`)])}>
        <header
          id="znanie-header"
          className={css.header}
          dangerouslySetInnerHTML={{
            __html: '<!--#include virtual="/header" -->',
          }}
          suppressHydrationWarning
        />
        <MainContent>{children}</MainContent>
        <footer
          id="znanie-footer"
          dangerouslySetInnerHTML={{
            __html: '<!--#include virtual="/footer" -->',
          }}
          suppressHydrationWarning
        />
      </div>
    </>
  );
}
